// ONE BOARD
export const GET_BOOK_DATA = 'GET_BOOK_DATA';
export const GET_BOOK_DATA_SUCCESS = 'GET_BOOK_DATA_SUCCESS';
export const GET_BOOK_DATA_FAILURE = 'GET_BOOK_DATA_FAILURE';

export const GET_PLACE_INFO = 'GET_PLACE_INFO';
export const GET_PLACE_INFO_SUCCESS = 'GET_PLACE_INFO_SUCCESS';
export const GET_PLACE_INFO_FAILURE = 'GET_PLACE_INFO_FAILURE';
